class NoCookieEnabledError extends Error {
  id: string;
  constructor() {
    super('Cookie Error');
    this.message = 'no_cookie_enabled_error';
    this.id = '';
  }
}

export { NoCookieEnabledError };
